import { CCol, CRow, CInput, CLabel, CButton, CSelect } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCall } from "src/_apiConfig/apiCall";
import Options from "../common/Options";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import {
  FilterContainsInsensitive,
  FilterKeyWord,
} from "../common/FilterCondition";

export const OfflinePaymentReqList = () => {
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [textField, settextField] = useState("paidByUser/emailId");
  const [emailIdSearch, setEmailIdSearch] = useState();
  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);
  const [itemPerPage, setItermPerPage] = useState(10);
  const [statusSearch, setstatusSearch] = useState(0);

  useEffect(() => {
    orderClick ? setorder("asc") : setorder("desc");
    getBidderList(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimit, textField, orderClick, itemPerPage]);

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    // if (textField !== getTextField) {
    //   setorder("asc");
    // } else {
    //   !orderClick ? setorder("asc") : setorder("desc");
    // }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  const fields = [
    {
      key: "userEmailId",
      label: TableHeaderSet("Email Address", "paidByUser/emailId"),
    },
    {
      key: "amount",
      label: TableHeaderSet("Mobile", "amount"),
    },
    {
      key: "insertDateTime",
      label: TableHeaderSet("Date", "insertDateTime"),
    },
    {
      key: "type",
      label: TableHeaderSet("Type", "type"),
    },
    {
      key: "TransferStatus",
      label: TableHeaderSet("Status", "status"),
    },
    {
      key: "show_details",
      label: <div>View</div>,
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  function reset() {
    setpageLimit(0);
  }
  const getBidderList = async (firstRequest) => {
    setloading(true);
    const header = new Headers();
    // header.append("", "");
    let filter = "";

    filter = "&$filter=";

    filter = FilterContainsInsensitive(
      filter,
      "paidByUser/emailId",
      emailIdSearch
    );
    filter = FilterKeyWord(filter, "status", statusSearch, "eq");

    if (filter === "&$filter=") {
      filter = "";
    }

    const response = await apiCall(
      `OfflinePayment/Get?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
        itemPerPage
      )}${filter}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      setuserData(jsonobj);
    }

    const responseCount = await apiCall(
      `OfflinePayment/Get?${filter}`,
      "GET",
      header,
      null
    );

    const jsonobjcount = await responseCount.json();

    if (responseCount.status === 200) {
    }

    setloading(false);

    pageLimit >= jsonobjcount.length - Number(itemPerPage)
      ? setdisablednext(true)
      : setdisablednext(false);

    pageLimit === 0 ? setdisabledprev(true) : setdisabledprev(false);
  };

  let additional = (
    <>
      <div>
        <CRow>
          <CCol xl={3}>
            <CLabel>Email Address:</CLabel>
            <CInput
              onChange={(e) => {
                setEmailIdSearch(e.target.value);
              }}
            />
          </CCol>
          <CCol xl={3}>
            <CLabel>Status:</CLabel>
            <CSelect
              onChange={(e) => {
                setstatusSearch(e.target.value);
              }}
              default="0"
            >
              <option value="0">Pending</option>
              <option value="1">Accepted</option>
              <option value="2">Rejected</option>
            </CSelect>
          </CCol>
        </CRow>
        <CButton
          className="mt-5  "
          color="success"
          onClick={() => {
            reset();
            getBidderList(false);
          }}
        >
          Search
        </CButton>
        <div className="float-right col-md-auto mt-3 mb-3 ">
          <CLabel>Item Per Page</CLabel>
          <CSelect
            aria-label="Default select example"
            onChange={(e) => {
              reset();
              setItermPerPage(e.target.value);
            }}
          >
            <Options />
          </CSelect>
        </div>
      </div>
    </>
  );
  return (
    <>
      <CRow>
        <CCol xl={12}>
          <CommonList
            items={usersData}
            fields={fields}
            listName="Offline Payment Search"
            loading={loading}
            path="/offlinepaymentslistview/"
            additional={additional}
            prev={() => setpageLimit(pageLimit - Number(itemPerPage))}
            next={() => setpageLimit(pageLimit + Number(itemPerPage))}
            disabledprev={disabledprev}
            disablednext={disablednext}
            tabBtn="View"
            id="id"
          />
        </CCol>
      </CRow>
    </>
  );
};

export default OfflinePaymentReqList;
